<div class="row">
  <div class="col-md-6 h2 mb-2">{{ type | titlecase }} cargo</div>
</div>

<button type="button" class="btn btn-outline-primary mb-2" (click)="copyData()">
  <i class="fa-solid fa-copt me-2"></i>
  <span>Copy data from other PCS services</span>
</button>

@for (goodsItem of list.controls; track goodsItem; let i = $index) {
  <div class="card position-relative my-3">
    <div class="position-absolute end-0">
      @if (list.length > 1) {
        <button class="btn btn-outline-danger rounded-circle p-1 px-2 h1 mb-0 me-2 mt-2 border-0 shadow-none"
                (click)="deleteGoodsItem(i)"
        >
          <i class="fa-light fa-trash-can"></i>
        </button>
      }
    </div>
    <div class="card-body p-4">
      <div class="row g-4">
        <app-form-field label="Ship to ship" class="col-12 col-md-3" [includeMargin]="false">
          <app-yes-no [formControl]="goodsItem.controls.shipToShip"
                      [required]="true"></app-yes-no>
        </app-form-field>
        <app-form-field class="col-12 col-md-3" label="Cargo type" [includeMargin]="false">
          <app-search [options]="Object.values(HarbourDuesCargoType)" [formControl]="goodsItem.controls.cargoType"
                      [inputFormatter]="PortvisitUtils.enumFormatter"
                      [required]="true" [placeholder]="'Type to search'"
                      (change)="toggleCargoType(i)"
          >
            <div class="invalid-feedback">Cargo type is required</div>
          </app-search>
        </app-form-field>
        <app-form-field class="col-12 col-md-3" [label]="cargoTypeIsContainer(i)?'Gross weight (kg)':'Gross weight (t)'"
                        [includeMargin]="false">
          <app-cargo-weight-amsterdam [weight]="goodsItem.controls.weight.value"
                            [unitOfMass]="cargoTypeIsContainer(i) ? UnitOfMass.KILOGRAM : UnitOfMass.METRIC_TON"
                            (weightChanged)="goodsItem.controls.weight.setValue($event)">
          </app-cargo-weight-amsterdam>
        </app-form-field>
        @if (type === 'discharge') {
          <app-form-field class="col-12 col-md-3" label="Port of loading" [includeMargin]="false">
            @if (type === 'discharge') {
              <app-search [formControl]="goodsItem.controls.portOfHandling"
                          [options]="PortvisitUtils.getPreviousPorts()"
                          [inputFormatter]="PortvisitUtils.portFormatter"
                          [minCharacters]="0" [required]="true"
                          [placeholder]="'Type to search'">
                <div class="invalid-feedback">Port of loading is required</div>
              </app-search>
            }
          </app-form-field>
        }
        @if (type !== 'discharge') {
          <app-form-field class="col-12 col-md-3" label="Port of discharge" [includeMargin]="false">
            @if (type !== 'discharge') {
              <app-search [formControl]="goodsItem.controls.portOfHandling" [searchFunction]="PortvisitUtils.findPort"
                          id="port" [placeholder]="'Type to search'" [inputFormatter]="PortvisitUtils.portFormatter"
                          [required]="true">
                <div class="invalid-feedback">Port of discharge is required</div>
              </app-search>
            }
          </app-form-field>
        }
        @if (!cargoTypeIsContainer(i)) {
          <app-form-field class="col-12 col-md-3" label="Goods code type" [includeMargin]="false">
            <app-radio [options]="['HS', 'UNDG']" [formControl]="goodsItem.controls.goodsCodeType"
                       (change)="toggleGoodsCodeType(i)" [required]="true" [inline]="true"></app-radio>
          </app-form-field>
          @if (goodsCodeTypeIsUndg(i)) {
            <app-form-field class="col-12 col-md-9" label="Goods code" [includeMargin]="false">
              <app-search [formControl]="goodsItem.controls.dangerInformation"
                          [inputFormatter]="PortvisitUtils.dangerInformationFormatter"
                          [searchFunction]="PortvisitUtils.findDangerInformation"
                          [minCharacters]="1"
                          [placeholder]="'Type to search'"
                          dataKey="code" [required]="true">
                <div class="invalid-feedback">HS/UNDG code is required</div>
              </app-search>
            </app-form-field>
          }
          @if (!goodsCodeTypeIsUndg(i)) {
            <app-form-field class="col-12 col-md-9" label="Goods code" [includeMargin]="false">
              <app-search [formControl]="goodsItem.controls.goodsClassification"
                          [inputFormatter]="PortvisitUtils.goodsClassificationFormatter"
                          [searchFunction]="PortvisitUtils.findClassifications"
                          [minCharacters]="1"
                          [placeholder]="'Type to search'"
                          dataKey="code" [required]="true">
                <div class="invalid-feedback">HS/UNDG code is required</div>
              </app-search>
            </app-form-field>
          }
        }
      </div>
    </div>
  </div>
}
@if (combinedWeightExceedsVesselDeadWeightKg()) {
  <div>
    <app-status-alert type="warning">Combined weight of {{ type }} cargo cannot
      exceed {{ context.getVesselDeadWeightKg() }} kg
    </app-status-alert>
  </div>
}
<button type="button" class="btn btn-outline-primary" (click)="addGoodsItem()">
  <i class="fa-solid fa-plus me-2"></i>
  <span>Add {{ type }} cargo</span>
</button>
